import { orderBy as _orderBy } from "lodash"
import React, { useEffect, useRef, useState } from "react"
import { Col, Row } from "react-bootstrap"
import { useHistory, useParams } from "react-router"

// Assets
import iconResendInvitation from "../../assets/images/Icon-ResendInvitation.svg"
import Trophy from "../../assets/images/Icon-Trophy.svg"
import PaperclipIcon from "../../assets/images/Paperclip.svg"

// Components
import ModalForm from "../../components/Modalform"
import MuiDataTable from "../../components/MuiDataTable"
import Statuslabel from "../../components/Statuslabel"
import { resendJoinAuctionEmail } from "../../redux/action/procurementAuctionAction"

// Redux
import { connect, useDispatch } from "react-redux"
import { getVendorItems } from "../../redux/action/auctionAction"
import {
   fetchParticipantByAuction,
   fetchProcurementVendors
} from "../../redux/action/procurementAction"

// Mui library
import ExpandLessIcon from "@mui/icons-material/ExpandLess"
import { TableBody, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material"

// #
import toast from "react-hot-toast"
import { Loader } from "rsuite"
import Constant from "../../../constant"
import Formservice from "../../services/Formservice"
import { safeMultiply, sumLineTotals } from "../../services/utils/CurrencyUtil"
import ProcurementVendorUtil from "../../services/utils/ProcurementVendorUtil"

function BuyerAuctionVendorList({
   isInitial,
   ranks,
   dataProcurement,
   // dataProcurementVendors,
   dataAuctionInvitations,
   dataProcurementVendors,
   setDataProcurementVendors,
   auctionId,
   winnerVendor,
   auctionStatus,
}) {
   const vendorAuctionHistoryRef = useRef()
   const dispatch = useDispatch()
   const { procurementId } = useParams()
   const history = useHistory()

   // Component state
   const [isLoading, setIsLoading] = useState(false)
   const [order, setOrder] = useState("asc")
   const [orderBy, setOrderBy] = useState("")
   const [finalOffer, setFinalOffer] = useState(null)
   // const [dataInvitedVendors, setDataInvitedVendors] = useState({})
   const [emptySearchResult, setEmptySearchResult] = useState(false)
   const [dataAuctionPerVendor, setDataAuctionPerVendor] = useState({})
   const [vendorUnitPriceHistory, setVendorUnitPriceHistory] = useState([])
   // const [dataProcurementVendors, setDataProcurementVendors] = useState({});
   const [dataState, setDataState] = useState({
      page: 0,
      limit: 5,
      query: "",
   })

   /**
    * Table handling
    * ----------------
    */
   const historyColumn = ["Item Code", "Item Name", "Qty", "UOM", "Unit Price", "Subtotal"]
   const handleRequestSortHistory = (column) => {
      const _order = order === "asc" ? "desc" : "asc"
      setOrderBy(column)
      setOrder(_order)

      const forColumn =
         column === "Item Code"
            ? "item.itemCode"
            : column === "Item Name"
            ? "item.itemName"
            : column === "Qty"
            ? "item.quantity"
            : column === "UOM"
            ? "item.uom"
            : column === "Unit Price"
            ? "lastPrice"
            : column === "Subtotal"
            ? "item.subTotal"
            : ""

      let result = []
      result = _orderBy(vendorUnitPriceHistory, [forColumn], [_order])

      setVendorUnitPriceHistory(result)
   }

   const search = () => {
      new Promise((resolve, reject) => {
         dispatch(
            fetchParticipantByAuction(
               { auctionId },
               (res) => {
                  resolve(res)
               },
               () => {
                  reject()
               },
            ),
         )
      })
         .then((procurementVendors) => {
            setIsLoading(true)
            const priceExist = procurementVendors.filteredData.filter((vendor) => vendor.lastPrice > 0).length > 0
            if (!priceExist) {
               setIsInitial(true)
               const filtered = ProcurementVendorUtil.searchInAuctionSession({
                  procurementVendors: procurementVendors.filteredData,
                  query: dataState.query,
               })
               setDataProcurementVendors((prev) => ({
                  ...prev,
                  filteredData: ProcurementVendorUtil.sortByPriceEvaluationRank(filtered),
               }))
            } else {
               let filtered = ProcurementVendorUtil.searchInAuctionSession({
                  procurementVendors: procurementVendors.filteredData,
                  query: dataState.query
               })
               filtered = ProcurementVendorUtil.sortByPriceEvaluationRank(
                  ProcurementVendorUtil.sortEvaluationScore(dataProcurement, filtered),
               )
               setDataProcurementVendors((prev) => ({ ...prev, filteredData: filtered }))
            }
         })
         .catch()
         .finally(() => {
            setIsLoading(false)
         })
   }

   const handleRowsPerPageChange = (v, { props }) => {
      const { value } = props
      dispatch(
         fetchProcurementVendors(
            {
               ...dataState,
               procurementId,
               limit: value,
            },
            (res) => {
               setDataProcurementVendors({
                  ...res,
                  filteredData: ProcurementVendorUtil.sortByPriceEvaluationRank(
                     ProcurementVendorUtil.sortEvaluationScore(dataProcurement, res.filteredData),
                  ),
               })
               setDataState({
                  ...dataState,
                  limit: value,
               })
               createItemsChecked(res.filteredData)
            },
         ),
      )
   }

   const handlePageChange = (v, newPage) => {
      dispatch(
         fetchProcurementVendors(
            {
               ...dataState,
               procurementId,
               page: newPage + 1,
            },
            (res) => {
               setDataProcurementVendors({
                  ...res,
                  filteredData: ProcurementVendorUtil.sortByPriceEvaluationRank(
                     ProcurementVendorUtil.sortEvaluationScore(dataProcurement, res.filteredData),
                  ),
               })
               setDataState({ ...dataState, page: newPage })
               createItemsChecked(res.filteredData)
            },
         ),
      )
   }

   /**
    * End
    * ----------------
    */

   const ColumnRank = ({ data: current, index }) => {
      if (isInitial) {
         return <TableCell data-testid={`cell-rank-${current._id}`} style={{ fontWeight: "700" }}>-</TableCell>
      } else {
         const rankingIndex = winnerVendor.findIndex((vendor) => vendor._id === current._id)
         const rank = ProcurementVendorUtil.displayRank(current, rankingIndex)
         const isQualitySystem = dataProcurement?.evaluationMethod === Constant.EVALUATION_METHODS.QUALITY_SYSTEM
         const isWinner =
         rankingIndex === 0 && (isQualitySystem || current.saving >= 0) && current.lastPrice > 0 && !current.isAboveCeiling

         return (
            <TableCell data-testid={`cell-rank-${current._id}`} sx={{ whiteSpace: "nowrap" }}>
               {(auctionStatus === "ON_GOING" || auctionStatus === "DONE") && !isInitial ? (
                  isWinner ? (
                     <span style={{ fontWeight: 700 }}>
                        {rank}
                        <img src={Trophy} style={{ marginLeft: "10px" }} />
                     </span>
                  ) : (
                     <span style={{ fontWeight: 700 }}>
                        {current.attendanceStatus === Constant.ATTENDANCE_STATUS.NOT_CONFIRMED ||
                        !current.indicatorPrice ||
                        current.isAboveCeiling
                           ? "-"
                           : rank}
                     </span>
                  )
               ) : (
                  <span>-</span>
               )}
            </TableCell>
         )
      }
   }

   const SendAuctionLink = ({ row, onSendingEmail }) => {
      const [timer, setTimer] = useState(0)

      const handleSendingEmail = () => {
         const procurementVendorId = row._id
         onSendingEmail(procurementVendorId)

         let seconds = 10
         setTimer(seconds)
         let timerInterval = setInterval(() => {
            if (seconds <= 0) {
               return clearInterval(timerInterval)
            } else {
               seconds--
               setTimer(seconds)
            }
         }, 1000)
      }

      return (
         <>
            {(timer <= 0 && (
               <a href="javascript:void(0);" onClick={() => handleSendingEmail()}>
                  <img src={iconResendInvitation} alt="" />
               </a>
            )) || (
               <>
                  <span>Available to resend in {timer}</span>
               </>
            )}
         </>
      )
   }

   useEffect(() => {
      if (vendorUnitPriceHistory.length > 0) {
         setFinalOffer(
            sumLineTotals(
               vendorUnitPriceHistory.map((v) => [v.lastPrice, v.item.quantity]),
               dataProcurement?.currency,
            ),
         )
      }
   }, [vendorUnitPriceHistory, dataProcurement?.currency])

   return (
      <>
         <MuiDataTable.CustomTable
            showHeader={true}
            stickyHeader={true}
            containerStyles={{
               maxHeight: "500px",
            }}
            headerComponent={
               <MuiDataTable.Filter
                  withSearchBar={true}
                  handleSearch={(v) => setDataState({ ...dataState, query: v.target.value })}
                  onKeyUp={(v) => v.keyCode === 13 && search()}
               />
            }
            // footerComponent={
            //    <TablePagination
            //       sx={{ background: "#ffffff", borderBottom: "none" }}
            //       page={dataState.page}
            //       count={dataProcurementVendors.total}
            //       rowsPerPage={dataState.limit}
            //       rowsPerPageOptions={[1, 2, 5, 10, 15, 20, { label: "All", value: -1 }]}
            //       onPageChange={handlePageChange}
            //       onRowsPerPageChange={handleRowsPerPageChange}
            //       className="d-flex justify-content-end"
            //    />
            // }
         >
            <TableHead>
               <TableRow>
                  <TableCell rowSpan={2} sx={{ whiteSpace: "nowrap", background: "#D0D6E0" }}>
                     Company Name
                  </TableCell>
                  <TableCell rowSpan={2} sx={{ borderRight: "1px solid #ffffff", background: "#D0D6E0" }}>
                     Attendance Status
                  </TableCell>
                  {[Constant.EVALUATION_METHODS.MERIT_POINT, Constant.EVALUATION_METHODS.QUALITY_SYSTEM].includes(dataProcurement?.evaluationMethod) && (
                     <TableCell
                        className="py-0"
                        colSpan={4}
                        align="center"
                        sx={{
                           borderRight: "1px solid #ffffff",
                           borderBottom: "1px solid #ffffff",
                        }}
                     >
                        Score
                     </TableCell>
                  )}
                  <TableCell
                     className="py-0 px-0"
                     rowSpan={2}
                     colSpan={2}
                     align="center"
                     sx={{ borderBottom: "1px solid #ffffff", background: "#D0D6E0" }}
                  >
                     <TableRow className="d-flex justify-content-center">
                        <TableCell
                           sx={{ background: "#D0D6E0", borderBottom: "1px solid #ffffff" }}
                           className="w-100 text-center py-2"
                        >
                           Price
                        </TableCell>
                     </TableRow>
                     <TableRow className="w-100" sx={{ borderBottom: "1px solid red" }}>
                        <TableCell
                           align="center"
                           sx={{ background: "#D0D6E0", borderBottom: "none" }}
                           className="py-2 w-100"
                        >
                           Indicator
                        </TableCell>
                        <TableCell
                           sx={{ background: "#D0D6E0", borderBottom: "none", whiteSpace: "nowrap" }}
                           className="py-2 w-100"
                           // align="center"
                        >
                           Last Price
                        </TableCell>
                     </TableRow>
                  </TableCell>
                  {/* <TableCell align="center" rowSpan={2} sx={{ borderLeft: "1px solid #ffffff", background: "#D0D6E0" }}>
                     Saving
                  </TableCell> */}
                  <TableCell rowSpan={2} sx={{ borderLeft: "1px solid #ffffff", background: "#D0D6E0" }}>
                     Rank
                  </TableCell>
                  <TableCell rowSpan={2} align="center" sx={{ background: "#D0D6E0" }}>
                     Letter Of Attorney
                  </TableCell>
                  {![Constant.STATUS.DONE, Constant.STATUS.CANCELED].includes(auctionStatus) && (
                     <TableCell rowSpan={2} align="center" sx={{ background: "#D0D6E0" }}>
                        Resend Link Auction
                     </TableCell>
                  )}
               </TableRow>
               <TableRow>
                  {[Constant.EVALUATION_METHODS.MERIT_POINT, Constant.EVALUATION_METHODS.QUALITY_SYSTEM].includes(dataProcurement?.evaluationMethod) && (
                     <>
                        <TableCell className="py-0">Administration</TableCell>
                        <TableCell className="py-0">Technical</TableCell>
                        <TableCell className="py-0">Price</TableCell>
                        <TableCell className="py-0" sx={{ borderRight: "1px solid #ffffff" }}>
                           Total
                        </TableCell>
                     </>
                  )}
                  {/* <TableCell className="py-0">Indicator</TableCell>
                  <TableCell className="py-0">Last</TableCell> */}
               </TableRow>
            </TableHead>
            <TableBody>
               {isLoading ? (
                  <TableRow>
                     <TableCell
                        sx={{ background: "#F3F5F4" }}
                        colSpan={
                           [Constant.EVALUATION_METHODS.MERIT_POINT, Constant.EVALUATION_METHODS.QUALITY_SYSTEM].includes(dataProcurement.evaluationMethod) ? 12 : 8
                        }
                        align="center"
                     >
                        <Loader speed="fast" content="Getting vendor data..." />
                     </TableCell>
                  </TableRow>
               ) : dataProcurementVendors?.filteredData?.length > 0 ? (
                  dataProcurementVendors?.filteredData?.map(
                     (v, index) => {
                        return (
                           <TableRow
                              key={index}
                              sx={{
                                 background: "#F3F5F4",
                                 "&:hover": {
                                    background: "transparent",
                                 },
                              }}
                           >
                              <TableCell
                                 data-testid={`cell-vendor-name-${v._id}`}
                                 style={{
                                    fontWeight: "700",
                                    minWidth: "200px",
                                    color:
                                       dataProcurement?.biddingType ===
                                          Constant.PROCUREMENT_BIDDING_TYPE.TOTAL_PRICE_BY_UNIT && "#454545",
                                    textDecoration:
                                       dataProcurement?.biddingType ===
                                          Constant.PROCUREMENT_BIDDING_TYPE.TOTAL_PRICE_BY_UNIT && "underline",
                                    cursor:
                                       dataProcurement?.biddingType ===
                                          Constant.PROCUREMENT_BIDDING_TYPE.TOTAL_PRICE_BY_UNIT && "pointer",
                                 }}
                                 onClick={() => {
                                    const vendorId = v._id
                                    dataProcurement?.biddingType ===
                                       Constant.PROCUREMENT_BIDDING_TYPE.TOTAL_PRICE_BY_UNIT &&
                                       vendorAuctionHistoryRef.current.show()
                                    dispatch(
                                       getVendorItems({ vendorId }, (res) => {
                                          setVendorUnitPriceHistory(res)
                                       }),
                                    )
                                    const dataVendor = dataProcurementVendors?.filteredData.filter(
                                       (data) => data._id == v._id,
                                    )
                                    setDataAuctionPerVendor(dataVendor[0])
                                 }}
                              >
                                 {v.name}
                              </TableCell>
                              <TableCell className="px-0">
                                 <Statuslabel
                                    label={v.attendanceStatus}
                                    status={v.attendanceStatus}
                                    styles={{ margin: "0" }}
                                 />
                              </TableCell>
                              {[Constant.EVALUATION_METHODS.MERIT_POINT, Constant.EVALUATION_METHODS.QUALITY_SYSTEM].includes(dataProcurement?.evaluationMethod) && (
                                 <>
                                    <TableCell className="px-0">
                                       <Statuslabel label="Passed" status="SUCCESS" />
                                    </TableCell>
                                    <TableCell align="right">{Formservice.ScoreFormatter(v.technicalScore)}</TableCell>
                                    <TableCell align="right">{Formservice.ScoreFormatter(v.priceScore)}</TableCell>
                                    <TableCell align="right">{Formservice.ScoreFormatter(v.totalScore)}</TableCell>
                                 </>
                              )}
                              <TableCell align="right" sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>
                                 {Formservice.CurrencyFormatter(v.indicatorPrice, {
                                    currency: dataProcurement?.currency,
                                 })}
                              </TableCell>
                              <TableCell data-testid={`cell-current-offer-${v._id}`} align="right" sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>
                                 {Formservice.CurrencyFormatter(v.lastPrice, { currency: dataProcurement?.currency })}
                              </TableCell>
                              {/* <TableCell align="right" style={{ fontWeight: "700" }}>
                                 {isInitial ? (
                                    <span>-</span>
                                 ) : (
                                    <span
                                       style={{
                                          color: v.saving > 0 ? "green" : v.saving < 0 ? "red" : "gray",
                                       }}
                                    >
                                       {v.saving.toFixed(2)}%
                                    </span>
                                 )}
                              </TableCell> */}
                              <ColumnRank data={v} index={index} />
                              <TableCell align="center">
                                 <a
                                    href="javascript:void(0);"
                                    onClick={() => {
                                       if (v.documents.length < 1) {
                                          toast.error("No letter uploaded!")
                                          return
                                       }
                                       v.documents.forEach((doc, index) => {
                                          window.open(doc.url), "_blank"
                                       })
                                    }}
                                 >
                                    <img src={PaperclipIcon} />
                                 </a>
                              </TableCell>
                              {![Constant.STATUS.DONE, Constant.STATUS.CANCELED].includes(auctionStatus) && (
                                 <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                    <SendAuctionLink
                                       row={v}
                                       onSendingEmail={(procurementVendorId) => {
                                          dispatch(resendJoinAuctionEmail(procurementVendorId, auctionId))
                                       }}
                                    />
                                 </TableCell>
                              )}
                           </TableRow>
                        )
                     },
                     // )
                  )
               ) : (
                  <TableRow sx={{ background: "#F3F5F4" }}>
                     <TableCell
                        colSpan={
                           [Constant.EVALUATION_METHODS.MERIT_POINT, Constant.EVALUATION_METHODS.QUALITY_SYSTEM].includes(dataProcurement?.evaluationMethod) ? 12 : 8
                        }
                        align="center"
                        sx={{ fontWeight: 500 }}
                     >
                        No records to display
                     </TableCell>
                  </TableRow>
               )}
            </TableBody>
         </MuiDataTable.CustomTable>

         {/* Vendor auction history modal */}
         <ModalForm passedInRef={vendorAuctionHistoryRef} title="Unit Price" closeButton={true}>
            {" "}
            <div style={{ padding: "0 26px 42px", overflow: "auto", height: "50vh" }}>
               <Row className="mb-3">
                  <Col lg={3} className="px-3">
                     Company
                  </Col>
                  <Col>{dataAuctionPerVendor && dataAuctionPerVendor.name}</Col>
               </Row>
               <Row className="mb-3">
                  <Col lg={3} className="px-3">
                     Indicator Price
                  </Col>
                  <Col>
                     {dataAuctionPerVendor &&
                        Formservice.CurrencyFormatter(dataAuctionPerVendor.indicatorPrice, {
                           currency: dataProcurement?.currency,
                        })}
                  </Col>
               </Row>
               <Row className="mb-4">
                  <Col lg={3} className="px-3">
                     Last Price
                  </Col>
                  <Col>
                     {dataAuctionPerVendor &&
                        Formservice.CurrencyFormatter(dataAuctionPerVendor.lastPrice, {
                           currency: dataProcurement?.currency,
                        })}
                  </Col>
               </Row>
               <MuiDataTable.CustomTable>
                  <TableHead>
                     <TableRow>
                        {historyColumn.map((column, index) => (
                           <TableCell
                              key={index}
                              className="py-2"
                              sx={{ whiteSpace: "nowrap" }}
                              align={index === 2 || index === 4 || index === 5 ? "right" : "left"}
                           >
                              <TableSortLabel
                                 active={orderBy === column}
                                 direction={order}
                                 IconComponent={ExpandLessIcon}
                                 onClick={() => handleRequestSortHistory(column)}
                              >
                                 {column}
                              </TableSortLabel>
                           </TableCell>
                        ))}
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {vendorUnitPriceHistory &&
                        vendorUnitPriceHistory.map((v, index) => (
                           <TableRow key={index} sx={{ background: "#F3F5F4" }}>
                              <TableCell className="py-2">{v.item.itemCode}</TableCell>
                              <TableCell className="py-2">{v.item.itemName}</TableCell>
                              <TableCell className="py-2" align="right">
                                 {Formservice.QuantityFormatter(v.item.quantity)}
                              </TableCell>
                              <TableCell className="py-2">{v.item.uom}</TableCell>
                              <TableCell className="py-2" sx={{ whiteSpace: "nowrap" }} align="right">
                                 {Formservice.CurrencyFormatter(v.lastPrice, { currency: dataProcurement?.currency })}
                              </TableCell>
                              <TableCell className="py-2" sx={{ whiteSpace: "nowrap" }} align="right">
                                 {Formservice.CurrencyFormatter(safeMultiply(v.lastPrice, v.item.quantity, dataProcurement?.currency), {
                                    currency: dataProcurement?.currency,
                                 })}
                              </TableCell>
                           </TableRow>
                        ))}
                     <TableRow sx={{ background: "#F3F5F4" }}>
                        <TableCell
                           colSpan={6}
                           align="right"
                           sx={{
                              fontWeight: 500,
                              whiteSpace: "nowrap",
                           }}
                           className="py-2"
                        >
                           <span className="mr-5">Total Offer</span>
                           {Formservice.CurrencyFormatter(finalOffer, { currency: dataProcurement?.currency })}
                        </TableCell>
                     </TableRow>
                  </TableBody>
               </MuiDataTable.CustomTable>
            </div>{" "}
         </ModalForm>
      </>
   )
}

const mapStateToProps = (state) => ({
   // dataProcurementVendors: state.procurementReducer.dataProcurementVendors,
   dataAuctionInvitations: state.auctionReducer.dataAuctionInvitations,
})

export default connect(mapStateToProps)(BuyerAuctionVendorList)
